module.exports = "/_next/static/images/FreePlan-xs-a0a09f8c892a4b121da9ec7cd94a40ca.webp";